import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/lib/site";
import { Reveal } from "../Reveal";

const SITE_TYPES = [
  "Covered 50-Amp Back-In",
  "50-Amp Back-In",
  "50-Amp Pull-Through",
  "30-Amp Back-In",
  "30-Amp Pull-Through",
] as const;

export function RvSiteOptions() {
  return (
    <section className="bg-background py-20 sm:py-24" aria-labelledby="rv-options-title">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="eyebrow text-clay">RV Site Options</p>
          <h2
            id="rv-options-title"
            className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.6rem]"
          >
            Find the Hookup Setup That Fits Your Rig
          </h2>
          <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg">
            Exact rates and availability should always be confirmed through the online reservation
            system for your selected dates.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SITE_TYPES.map((type, i) => (
            <Reveal as="li" key={type} delay={(i % 3) * 0.06} y={20}>
              <div className="flex min-h-[88px] items-center border-t border-sand bg-surface px-5 py-6 transition-colors duration-300 hover:border-forest/30">
                <p className="font-display text-xl text-forest-deep">{type}</p>
              </div>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.1} className="mt-10">
          <Button asChild variant="forest" size="cta">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              View Current Availability <ArrowUpRight aria-hidden="true" />
            </a>
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
